$(function () {
    $('input[type=password][name=password]').pStrength({
        bind: 'keyup change blur',
        changeBackground: true,
        backgrounds: [
            ['#cc3333', '#FFF'],
            ['#cc3333', '#FFF'],
            ['#cc3333', '#FFF'],
            ['#cc3333', '#FFF'],
            ['#cc3333', '#FFF'],
            ['#e8a53a', '#FFF'],
            ['#e8a53a', '#FFF'],
            ['#e8a53a', '#FFF'],
            ['#33cc33', '#FFF'],
            ['#33cc33', '#FFF'],
            ['#00cc00', '#FFF'],
            ['#00cc00', '#FFF'],
            ['#00cc00', '#FFF'],
        ],
        onPasswordStrengthChanged: function (passwordStrength, percentage) {
            var meter = $('div.strength span');
            //var icon = meter.parents('li').find('.icon-valid');
            meter.animate(
                {
                    width: percentage + '%',
                },
                {
                    duration: 500,
                    queue: false,
                },
            );
        },
    });
});
